import Dexie from 'dexie';

const db = new Dexie('carcheck.images');
db.version(1).stores({ images: 'id++, imageId, formId, status' });
db.version(2).stores({ images: 'id++, imageId, formId, status, path' });

export default db;
